import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import MainNavbar from '@/components/MainNavbar';
import MainFooter from '@/components/MainFooter';

/*
  Esqueleto común de la web pública: cabecera fija + página + pie (decisión de Samuel, 09/10/2026).
  La cabecera y el pie no se vuelven a montar al navegar, así el menú es siempre el mismo.
  Fuera de este esqueleto quedan solo el área de miembros (/dashboard) y las landings por enlace directo /presentacion, /masterclass y /masterclass-en-directo.
*/
export default function PublicLayout() {
  const { pathname, hash } = useLocation();

  // Al cambiar de página se empieza arriba (o en el ancla, si la hay)
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => document.querySelector(hash)?.scrollIntoView({ behavior: 'smooth' }), 120);
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
    return undefined;
  }, [pathname, hash]);

  return (
    <>
      <MainNavbar />
      <Outlet />
      <MainFooter />
    </>
  );
}
